import { useQuery } from "react-query";
import { useHistory, useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

import { fetcher } from '../../client';
import { fetchProfile, fetchDashboardStats } from '../../actions/profile';
import { useAuthState } from '../../../context/auth';
import i18n from '../../../i18n';

export function useProfile() {
  const history = useHistory();
  const location = useLocation();
  const auth = useAuthState();
  const profileResponse = useQuery(['profile',auth.user?._id], () => fetcher(fetchProfile()), {
    enabled: !!auth.user?._id,
    keepPreviousData: true,
    staleTime: 30 * 1000,
    onSuccess: (data) => {
      if (i18n.language !== data?.language) {
        i18n.changeLanguage(data?.language);
      }
      if (!data?.hasInitialConfig) {
        history.push("/account-setup");
      } else if (location.pathname === "/account-setup") {
        history.push("/");
      }
      ReactGA.set({
        userId: data._id,
        source: "starter",
      });
    },
  });

  const can = (privilege) => {
    if (!profileResponse?.data?.roles) return false;
    return profileResponse?.data?.roles?.includes(privilege);
  };


  return { ...profileResponse, profile: profileResponse.data || {}, can }
}

export function useFetchDashboardStats(options = {}) {
  return useQuery(['dashboard-stats'], () => fetcher(fetchDashboardStats()), options)
}
